let logistic = {
    name: "logistic",
    url: '/logistic',
    template: '<div ui-view></div>',
}
let logistic_orders = {
    name: 'logistic.orders',
    url: '/orders',
    component: 'logisticOrderList'
}
let logistic_orders_detail = {
    name: 'logistic.orderDetail',
    url: '/orders/:orderId',
    component: 'logisticOrderDetail'
}

export let logisticRoute = [
    logistic,
    logistic_orders,
    logistic_orders_detail,
];


// WEBPACK FOOTER //
// ./src/store-modules/app/route/logistic/logistic-route.ts